// extracted by mini-css-extract-plugin
export default {"input":"styles_input__qIGBQ","desc":"styles_desc__LmH8j"};